import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import CollaboratorsVacationsForm from "./CollaboratorsVacationsForm";



const CallViewCollaboratorsVacations = ({ match }) => {
    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <CollaboratorsVacationsForm userId={match.params.id} context={"view"} />

        </div>
    );
}

export default CallViewCollaboratorsVacations;